// extracted by mini-css-extract-plugin
export default {"form":"_02_Phone_form__XVFtF","root":"_02_Phone_root__MAkxW","phone":"_02_Phone_phone__A3afG"};